module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UtKvbb/images/the-cutter.jpg?1734954345722",
      "alt": "This image is the cover for the book Cutter"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cutter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In the eerie fog of Moorford Ridge, the past never truly dies . . .")]), _c('br'), _c('br'), _vm._v(" Decades after the original Cutter murders terrorized Moorford Ridge, a new wave of killings begins, marked by the same chilling signature—a single word carved into flesh. Detective Sergeant Brady, a haunted man with a troubled past, is thrust into a nightmarish investigation that blurs the line between history and horror."), _c('br'), _c('br'), _vm._v(" When a local historian becomes the prime suspect, Brady finds himself drawn into a twisted web of secrets that stretches back a century. As the body count rises, so do the stakes—and the detective is forced to confront his own demons while racing against time to unmask a killer born from the town’s darkest legends."), _c('br'), _c('br'), _vm._v(" With each step, Brady uncovers truths that shake the very foundation of Moorford. But in a town where the past is still alive, can the detective stop the bloodshed before the Cutter claims another victim? Or will the shadows of history finally consume him?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert Devine\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0